import { carouselData } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-100">焦点专题</h2>
          <p className="text-sm text-foreground-500 mt-3">本周最受关注的热门内容</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {carouselData.map((item, i) => (
            <div key={i} className={`group rounded-xl overflow-hidden bg-background-50 border border-background-200/50 hover:border-primary-500/30 transition-all cursor-pointer ${
              i === 0 ? 'lg:col-span-2' : ''
            }`}>
              <div className={`relative overflow-hidden ${i === 0 ? 'aspect-[16/7]' : 'aspect-[16/9]'}`}>
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-background-950/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                  <p className="text-xs text-primary-400 font-medium mb-1">{item.subtitle}</p>
                  <h3 className="text-base md:text-lg font-bold text-foreground-100">{item.title}</h3>
                  {i === 0 && (
                    <p className="text-xs md:text-sm text-foreground-300 mt-2 line-clamp-2 leading-relaxed">{item.desc}</p>
                  )}
                </div>
              </div>
              {i !== 0 && (
                <div className="p-4">
                  <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">{item.desc}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}